import styled from "@emotion/styled"
import TextField from "../Radiate/TextField/TextField"

export const PicPreview = styled.div`
  .pic-preview {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    overflow: hidden;
    background: #eee;
    margin-right: 16px;
    flex-shrink: 1;
    object-fit: cover;
  }
`

export const FlexTextField = styled(TextField)`
  width: 32%;
`

export const Label = styled.div`
  font-size: ${(props) => props.theme.textSm};
  display: flex;
  align-items: center;
  padding-top: 8px;

  >span {
    padding-right: 4px;
  }
`

export const InfoWrapper = styled.div`
  border-left: 3px solid ${props => props.theme.gray4};
  padding-left: 8px;
`